<template>
  <div>
    <b-modal
        :title="$t('Meeting schedules')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="xl"
        no-close-on-backdrop lazy>
      <b-row class="mb-2">
        <div class="col-md-12">
          <a href="#" @click.prevent="addSchedule"><img :src="`images/btn-add-${locale}.png`" /></a>
        </div>
      </b-row>
      <div class="row list-schedules">
        <div class="col-md-12 col-lg-6 col-xl-4" v-for="(schedule, index) in schedules" :key="index">
          <b-card class="schedule-item" @click="editSchedule(schedule)">
            <div class="d-flex position-relative">
              <button class="btn btn-sm btn-danger btn-delete" @click="deleteSchedule(schedule)">
                <b-icon icon="trash"></b-icon>
              </button>
              <div class="schedule-image">
                <div class="image">
                  <b-icon icon="calendar3"></b-icon>
                </div>
                <button @click="changeStatus(schedule)" :class="schedule.Status !== '' ? 'status' : 'status active'"
                        v-b-tooltip.hover :title="$t(schedule.Status !== '' ? 'Deactivate' : 'Activate')">
                  <b-icon :icon="schedule.Status !== '' ? 'lock-fill': 'unlock-fill'"></b-icon>
                </button>
              </div>
              <div class="schedule-info">
                <div class="name">
                  <div>{{ schedule.Name }}</div>
                </div>
                <div class="time">
                  <b-icon icon="clock-fill"></b-icon>
                  {{ schedule.Time }}
                </div>
                <div class="date">
                  <b-icon icon="calendar2-date"></b-icon>
                  {{ schedule.Date }} <span v-if="meetingType == 3">({{ schedule.Day }})</span>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
    <EditScheduleModal ref="editScheduleModal" @saveChanges="saveChanges"/>
  </div>
</template>

<script>
import EditScheduleModal from "./EditScheduleModal";
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "MeetingSchedulesModal",
  components: {EditScheduleModal},
  data: function () {
    return {
      show: false,
      loading: false,
      lock: false,
      locale: "en",
      schedules: [],
      meetingType: 1,
    }
  },
  beforeCreate() {
    this.locale = this.$store.getters.languageCode;
  },
  methods: {
    open() {
      this.load();
      this.show = true;
    },
    async load() {
      this.loading = true;
      let response = await meetingService.meetingSchedules();
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let data = JSON.parse(response.substr(3));
      this.schedules = data.Schedules;
      this.meetingType = data.IDMeetType;
    },
    async changeStatus(schedule) {

    },
    async deleteSchedule(schedule) {
      if (this.loading)
        return;

      this.lock = true;
      const result = await dialogHelper.confirm("Are you sure to delete this meeting schedule?");
      if (!result) {
        this.lock = false;
        return;
      }

      this.loading = true;
      let response = await meetingService.deleteMeetingSchedule(schedule.ScheduleID);
      this.loading = false;
      this.lock = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let data = JSON.parse(response.substr(3));
      this.schedules = data.Schedules;
      this.meetingType = data.IDMeetType;
      dialogHelper.alert(data.Msg, "success");
    },
    editSchedule(schedule) {
      if (this.lock)
        return;

      if (this.meetingType == 2)
        this.$refs.editScheduleModal.edit2(schedule.ScheduleID);
      else
        this.$refs.editScheduleModal.edit3(schedule.ScheduleID);
    },
    addSchedule() {
      this.$refs.editScheduleModal.addSchedule(this.meetingType);
    },
    saveChanges(schedules) {
      this.schedules = schedules;
    }
  },
  watch: {
    show: function (newValue) {
      if (newValue)
        return;

      this.schedules = [];
      this.meetingType = 1;
    }
  }
}
</script>

<style scoped>

</style>